<template>
  <div class="sidebar">
    <div class="bg-primary-dark text-on-primary-dark px-4 py-3">
      <div class="large-prompt mt5 mb5">
        {{ i18n.t('calendars.near_events.search_label') }}
      </div>
      <search-bar class="search-bar mt20"
                  :initial-query="locationQuery"
                  @search="applyLocationFilter">
        <template #search-button>
          <button type="submit" class="search-button" :title="i18n.t('search')">
            {{ i18n.t('search') }}
          </button>
        </template>
      </search-bar>
      <advanced-filters-section v-if="showAdvancedFilters"
                                class="advanced-filters-section"
                                :allowed-filter-keys="allowedAdvancedFilters"
                                selected-value-display-variety="inverted-accent"
                                @change="applyAdvancedFilterChange" />
    </div>
    <location-list :class="[{translucent: isLoadingList}, 'location-list']"
                   :locations="detailedLocations"
                   :event-item-component="eventItemComponent"
                   :event-item-first-component="eventItemFirstComponent"
                   :empty-list-component="emptyListComponent"
                   @paginate="onPaginate" />
    <slot name="sidebar-footer" />
  </div>
</template>

<script>
import AdvancedFiltersSection from './advanced-filters-section'
import LocationList from './location-list'
import SearchBar from './search-bar'
import EventListItemWide from './event-list-item-wide'
import EventListItemWideHighlighted from './event-list-item-wide-highlighted'
import EmptyEventListWide from './empty-event-list-wide'
import { localListMixin } from './local-list-mixin'
import { mapState } from 'vuex'

export default {
  components: {
    AdvancedFiltersSection,
    LocationList,
    SearchBar
  },

  mixins: [ localListMixin ],

  props: {
    emptyListComponent: {
      type: Object,
      default: () => EmptyEventListWide
    }
  },

  data() {
    return {
      eventItemComponent: EventListItemWide,
      eventItemFirstComponent: EventListItemWideHighlighted
    }
  },

  computed: {
    ...mapState(['isLoadingList'])
  }
}
</script>

<style lang="scss" scoped>
@use "~friendship_styles/colors" as colors;

.location-list {
  > ::v-deep(ul > li:not(:last-child)) {
    margin-bottom: 20px;
    border-bottom: 1px solid #ECECEC;
  }
}

.search-bar {
  display: flex;
}

.search-button {
  font-size: 18px;
  padding: 0 10px;
  line-height: 100%;
  background-color: colors.$black;
  border-color: colors.$black;
  border-radius: 0 4px 4px 0;
  color: white;
  z-index: unset;
  height: 100%;

  &:hover, &:active {
    background-color: colors.$black;
    border-color: colors.$black;
  }
}

.translucent {
  opacity: colors.$loading_opacity;
}
</style>
